<template>
	<div>
	<v-container style="margin-top: 10px">
		<v-row>
			<v-col offset="1" cols="3">

				<v-select v-model="selected_client" :items="liste_clients" item-text="nom_user" item-value="id_user"
					label="Client" hide-details chips dense prepend-inner-icon="mdi-filter"></v-select>
			</v-col>
			<v-col offset="1" cols="3">
				<v-select v-model="filtre_select_departement_mycolis" :items="liste_departement_mycolis"
					label="Département" hide-details chips dense prepend-inner-icon="mdi-filter"></v-select>
			</v-col>
		</v-row>

	<!--  Import CSV / XLS -->
	<h3 v-on:click="show_import_plot = !show_import_plot">Corriger ou Importer des parcelles Mycolis
		<v-icon small class="mr-2" v-if="!show_import_plot">
			mdi-chevron-down
		</v-icon>
		<v-icon small class="mr-2" v-else>
			mdi-chevron-up
		</v-icon>
	</h3>

		<div v-if="show_import_plot" style="margin-bottom:20px;margin-top:20px;">
			<v-row>
				<v-col cols="3">
					<v-btn small color="white" class="mt-2 white--text">
						<a href="./import_parcellesMycolis_fichierType.csv"
							download="import_parcellesMycolis_fichierType.csv">Obtenir format csv d'import</a>
						<v-icon small class="mr-2">
							mdi-download
						</v-icon>
					</v-btn>
				</v-col>
				<v-col offset="1" cols="2">
					<v-select v-model="selected_user_mycolis" :items="liste_users_mycolis" item-text="nom_user"
						item-value="code_organisme" menu-props="auto" label="Client" hide-details chips dense></v-select>
				</v-col>
				<v-col offset="1" cols="2">
					<div class="form-group">
						<v-file-input label="Fichier" outlined dense v-model="chosenFile" @change="resetFormAndDataErrors()"></v-file-input>
					</div>
					<p v-if="chosenFile!=null"> Le fichier actuel contient <strong>{{nbr_plot_csv}}</strong> parcelle(s).
					</p>
				</v-col>
                <!-- BOUTONS ACTIONS Avant IMPORT -->
                <v-col cols="2" offset="1" class="d-flex justify-center">
					<v-btn color="success" class="white--text" @click="checkConformCSVdata() ; dialog_bilan_check_csv=true" v-if="chosenFile!=null && selected_user_mycolis!=null">
						<span>Verifier</span>
					</v-btn>
				</v-col>
			</v-row>
		
			<br>
				<!--APERCU DES CORRECTIFS suites à la fonction check checkConformCSVdata -->
				<div style="width:70% !important;">
					<v-dialog v-model="dialog_bilan_check_csv">
						<v-card>
							<v-toolbar color="primary" dark>
								<v-toolbar-title>Bilan des écarts à corriger</v-toolbar-title>
								<v-spacer></v-spacer>
								<v-btn icon @click="dialog_bilan_check_csv = false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-toolbar>
							<v-card-text style="margin:0.2rem !important">
								<br>
								<pre>{{ csvSummary }}</pre>
								<br><hr v-if="groupedErrorsVar.length > 0" style="width:100% !important"><br>
								<table v-if="groupedErrorsVar.length > 0" style="width:100% !important">
                                    <thead>
                                        <tr>
                                            <th>Nbr de lignes concernées</th>
                                            <th>Erreur</th>
                                            <th>Suggestions</th>
                                            <th>Correction</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="error in groupedErrorsVar" :key="error.erreur">
                                            <td style="text-align: center">{{ error.nombreLignes }}</td>
                                            <td>{{ error.erreur }}</td>
                                            <td style="text-align: center">
                                                {{ formatSuggestionsText(error.suggestions) }}
                                            </td>
                                            <td>
                                                <v-combobox
                                                    v-show="error.suggestions && error.suggestions.length > 0"
                                                    v-model="error.correction"
                                                    :items="formatSuggestions(error.espece, error)"
                                                    label="Choisir une correction"
                                                    clearable
                                                    @change="toutesSuggestionsRemplies()"
                                                    @update:modelValue="mettreAJourCorrection(error)"
                                                ></v-combobox>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


							</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>

                                <v-btn color="success" @click="corrigerCsvPuisTelecharger()">
                                    Télécharger Fichier corrigé 
                                    <v-icon small class="mr-2">
                                        mdi-download
                                    </v-icon>
                                </v-btn>

								<v-btn color="success" @click="launchAddPlotInApi() ; dialog_bilan_check_csv = false" :disabled="!goToImport || tauxErreur > 0 ">
                                    Importer   <v-icon small class="mr-2">
									mdi-database-import-outline
								</v-icon>
                                </v-btn>

							</v-card-actions>
						</v-card>
					</v-dialog>

					<!--DIALOGUE FIN D IMPORT -->
				</div>
			<!--FIN APERCU DU CSV -->


			<!--APERCU DU CSV -->
			<div>
				<v-dialog v-model="dialog_view_csv">
					<v-card style="overflow:auto;">
						<v-toolbar color="primary" dark class="mb-5"> Aperçu du fichier à importer </v-toolbar>
						<v-card-text style="height:300px;overflow:auto;">
							<table style="font-size: smaller; margin:0.5rem;overflow:scroll;width:1800px!important">
								<thead>
									<tr>
										<th v-for="key in parse_header" :key="key.id" @click="sortBy(key)"
											:class="{ active: sortKey == key }">
											{{ key | capitalize }}
											<span class="arrow" :class="sortOrders[key] > 0 ? 'asc' : 'dsc'">
											</span>
										</th>
									</tr>
								</thead>
								<tr v-for="csv_line in parse_csv" :key="csv_line.id">
									<td v-for="key in parse_header" :key="key.id">
										{{csv_line[key]}}
									</td>
								</tr>
							</table>
						</v-card-text>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn small color="info" class="mt-2 mb-50 white--text" @click="launchAddPlotInApi()">
								<v-icon small class="mr-2">
									mdi-database-import-outline
								</v-icon>
								Importer les données
							</v-btn>
							<v-btn color="primary" text @click="dialog_view_csv = false">
								Fermer
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
				<!--DIALOGUE FIN D IMPORT -->
			</div>
			<!--FIN APERCU DU CSV -->
		</div>
		<!-- FIN  Import CSV / XLS -->

        <h3>
            Parcelles Mycolis 
            <span v-if="filteredData.length !== all_info_about_stades.length">
                ( {{ filteredData.length }} / {{ all_info_about_stades.length }} )
            </span>
            <span v-else>
                ({{ all_info_about_stades.length }})
            </span>
        </h3>
		<v-card>
        <!-- L MAP -->
        <v-row class="fill-height" style="margin-top: 1rem;" v-if="showMap">
            <v-col offset="1" xs="10" class="d-flex align-center justify-center">
                <l-map style="width:90% !important; height:400px !important" 
                    :center="carte.center" 
                    :zoom="carte.zoom" 
                    class="map" 
                    ref="map" 
                    @update:zoom="zoomUpdated" 
                    @update:center="centerUpdated">
                    <l-tile-layer :url="carte.url"></l-tile-layer>
                    <l-marker v-for="marker in filteredMarkers" 
                            :key="marker.id" 
                            :lat-lng="marker.coordinates">
                        <l-icon ref="icon" :icon-url="marker.imageUrl"></l-icon>
                        <l-popup :content="marker.infobulle" />
                    </l-marker>
                </l-map>
            </v-col>
        </v-row> 
        <!-- FIN L MAP -->

		<v-card-title>
			<v-spacer></v-spacer>
			<v-text-field
			v-model="searchWord_cap"
			append-icon="mdi-magnify"
			label="Recherche par mot clé"
			single-line
			hide-details
			></v-text-field>
		</v-card-title>
		<!--https://codepen.io/wolfpup/pen/gOadmPx-->
		<v-data-table
            :items="filteredData"
            item-key="id_plot"
			:headers="headers"
			:search="searchWord_cap"
			dense
		>
		</v-data-table>
		</v-card>
		<!--EXCEL-->
		<v-btn small color="info" class="mt-2 mr-5 white--text">
		<download-excel :data="filteredData" :name="getNomFichier()">
			Export Excel
			<v-icon small class="mr-2">
			mdi-download
			</v-icon>
		</download-excel>
		</v-btn>

	</v-container>
	
	</div>
</template>

<script>
import CommentaireComponent from "@/components/global/CommentaireSimple.vue";
import downloadExcel from "vue-json-excel";
import parcellesStadeService from "@/service/parcellesStade";
import { getDate } from "@/helpers/functions";
import { LMap, LTileLayer, LMarker, LIcon, LPopup } from 'vue2-leaflet';


export default {
	name: "Mycolis",
	components: {
	CommentaireComponent,
	downloadExcel,
	parcellesStadeService,
	LMap,
	LIcon,
	LPopup,
	LMarker,
	LTileLayer

	},
	data() {
	return {
		dialog_view_csv: false,
        goToImport : false, // autoriser le bouton import en bdd
		dialog_bilan_check_csv: false, // Visuel sur les erreurs de verif
		csvErrorsVar: [], // tableau pour stocker les erreurs de vérif sur les varietes 
		csvErrorsDetailByLigne:[], // tableau des erreurs en detail pour chaque ligne ( plusieurs erreur possibles par lignes)
		csvSummary: "",   
		dialog_api : false,
		chosenFile: null,
		show_import_plot: false,
        showMap: false, // La carte est masquée par défaut
		//csv: null,
		searchWord_cap: '',
		all_info_about_stades:[],
		headers: [
            //colonnes visibles
            { text: "Code client", value: "nom_operateur"},
            { text: "id_operateur", value: "id_operateur"},
            { text: "id_user", value: "id_user"},
            { text: "nom_user", value: "nom_user"},
            { text: "code_parcelle_os", value: "code_parcelle_os"},
            { text: "id_plot", value: "id_plot"},
            { text: "codeespece", value: "codeespece"},
            { text: "date_semis", value: "date_semis"},
            { text: "variete", value: "variete"},
            { text: "labour", value: "labour"},
            { text: "code_precedent", value: "code_precedent"},
            { text: "a_calculer", value: "a_calculer"},
            { text: "date_calcul", value: "date_calcul"},
            { text: "date_fin_previsions", value: "date_fin_previsions"}
		],
		parse_header: [],
		parse_csv: [],
		sortOrders:{},
		sortKey: '',
		nbr_plot_csv:0,
		message_api:'',
		array_message_erreur_api:[],
		arr_data_base_64:[],
		arr_data_plot_foreach_plot : [],
		arr_all_data_plot_foreach_plot: [],
		liste_users_mycolis: [],
		selected_user_mycolis: null,
		liste_departement_mycolis: [],
        selected_client: "Tous",
        filtre_select_departement_mycolis: "Tous",
		// MAP
			carte:{
			url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			center: [ 46.76782, 2.43129 ],
			zoom: 5,
			markers: [],
		},
		liste_precedents : [],
		liste_variete_ble: [],
        suggestion_toutes_prises: false,
        tauxErreur: 0,
        list_all_cp_gouv : null,
        statsLocalisation : {
            totalSansAucuneInfo: 0,
            inseeManquant: 0,
            communeOuCpManquant: 0,
            gpsHorsBornes: 0,
            coordonnees_non_retrouvees:0
        }
        
    };
	},

	watch: {

        message_api: function(){
            this.resultat_message(this.message_api)
        },
        chosenFile: function(){
            this.viewCSV()
        },

        groupedErrorsVar: {
            deep: true,
            handler() {
                this.$forceUpdate(); // Force la mise à jour pour assurer que le computed est recalculé
            }
        },

        selected_client(newValue) {
        // Vérifie si un client est sélectionné
        this.updateShowMap();
        },
        filtre_select_departement_mycolis(newValue) {
        // Vérifie si un département est sélectionné
        this.updateShowMap();
        }
    

	},

	computed: {

	//Liste des clients (opérateurs) + "tous"
	liste_clients() {
		return ["Tous",...new Set(this.all_info_about_stades.map(p => p.nom_user))];
	},

    groupedErrorsVar() {
        let grouped = {};
        this.csvErrorsVar.forEach(error => {
            let key = error.erreur; // Grouper par message d'erreur

            if (!grouped[key]) {
                grouped[key] = {
                    erreur: error.erreur,
                    espece: error.espece, // Stocke l'espèce associée
                    nombreLignes: 0, // Compteur du nombre de lignes concernées
                    suggestions: error.suggestions, // Stocke les suggestions
                    correction: "", // Initialisation de la correction
                };
            }
            grouped[key].nombreLignes++; // Incrémente le compteur de lignes
        });

        return Object.values(grouped); // Convertir en tableau
    },
    

    filteredData() {
        return this.all_info_about_stades.filter(parcelle => {
        const matchClient = this.selected_client === "Tous" || parcelle.nom_user === this.selected_client;
        const matchDepartement = this.filtre_select_departement_mycolis === "Tous" || parcelle.code_dept === this.filtre_select_departement_mycolis;
        return matchClient && matchDepartement;
        });
    },

    // Données de la carte, filtrées uniquement si 1 filtre actif
    filteredMarkers() {
        if (this.showMap) {
        return this.formatMarkers(this.filteredData);
        }
        return [];
    }
    

},

	async mounted() {

	/*if((this.$store.getters['cap/ParcellesList']()).length==0){
		this.$store.dispatch('general/setWaitingOverlay', { loading: true, fullpage: true });
		this.all_info_about_stades = await parcellesStadeService.getInfos(this.$route.params.id);
		this.$store.commit('cap/defineParcellesList',{stades:this.all_info_about_stades});
		this.$store.dispatch('general/setWaitingOverlay', { loading: false, fullpage: true });
	} 

	this.all_info_about_stades = this.$store.getters['cap/ParcellesMycolis']*/

    this.list_all_cp_gouv = await parcellesStadeService.getAllCpGouv();

	if ((this.$store.getters['cap/ParcellesListMycolis']()).length == 0) {
		this.$store.dispatch('general/setWaitingOverlay', { loading: true, fullpage: true });
		this.all_info_about_stades = await parcellesStadeService.getInfos('mycolis');
		this.$store.commit('cap/defineParcellesListMycolis', {
		stades: this.all_info_about_stades
		});
		this.$store.dispatch('general/setWaitingOverlay', { loading: false, fullpage: true });
	} else {
		this.all_info_about_stades = this.$store.getters['cap/ParcellesListMycolis']()
	}

        this.liste_users_mycolis = await parcellesStadeService.getUsersMycolis();
        this.liste_departement_mycolis = this.get_departement_mycolis();

        this.getPositionCarte();
        this.liste_precedents = await parcellesStadeService.getListPrecedent();
        this.liste_variete_ble = await parcellesStadeService.getListVarieteCulture('bledur,bletendre','maladie');


	},

	filters: { // TODO CHECK - CSV visio
		capitalize: function (str) {
			return str.charAt(0).toUpperCase() + str.slice(1)
		}
	},

	methods: {

        updateShowMap() {
            // La carte ne sera affichée que si un client ou un département autre que "Tous" est sélectionné
            this.showMap = this.selected_client !== "Tous" || this.filtre_select_departement_mycolis !== "Tous";        
            },

        normalizeCommuneName(commune) {
                if (!commune) return "";

                try {
                    commune = decodeURIComponent(escape(commune)); // Pour gérer les encodages incorrects
                } catch (e) {
                    console.warn(`⚠️ Problème d'encodage avec la commune : "${commune}"`);
                }

                // Correction des erreurs d'encodage courantes (comme avant)
                let corrections = {
                    "Ã©": "é", "Ã¨": "è", "Ãª": "ê", "Ã«": "ë", "Ã¢": "â", "Ã¤": "ä",
                    "Ã¹": "ù", "Ã»": "û", "Ã¼": "ü", "Ã§": "ç", "Ã®": "î", "Ã¯": "ï",
                    "Ã´": "ô", "Ã¶": "ö", "Ã€": "À", "Ã‚": "Â", "Ãƒ": "Ã", "Ã„": "Ä"
                };

                Object.keys(corrections).forEach(key => {
                    commune = commune.replace(new RegExp(key, "g"), corrections[key]);
                });

                // Suppression des accents et transformation en majuscules
                commune = commune.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase();

                // Remplacer "SAINT" par "ST" et gérer les tirets
                commune = commune.replace(/\bSAINT\b/g, 'ST');  // Remplacer SAINT par ST
                commune = commune.replace(/-/g, ' ');  // Remplacer les tirets par des espaces
                commune = commune.replace(/\s+/g, ' ').trim(); // Supprimer les espaces multiples et trim

                return commune;
            },



        // telechargerCsvCorrige() {
        //     // Ajouter les corrections avant l'export
        //     this.ajouterColonneCorrections();

        //     let csvContent = "data:text/csv;charset=utf-8,\uFEFF"; 

        //     // Définir l'ordre des colonnes (n_ligne d'abord, puis le reste)
        //     let headers = ["n_ligne", ...Object.keys(this.parse_csv[0]).filter(h => h !== "n_ligne")];
        //     csvContent += headers.join(";") + "\n";

        //     // Ajouter les lignes corrigées
        //     this.parse_csv.forEach(row => {
        //         let values = headers.map(h => row[h]); // Respecter l'ordre défini
        //         csvContent += values.join(";") + "\n";
        //     });

        //     console.log( csvContent.length)
        //     console.log(JSON.stringify(csvContent));

        //     // Créer un fichier Blob et le télécharger
        //     let encodedUri = encodeURI(csvContent);
        //     let link = document.createElement("a");
        //     link.setAttribute("href", encodedUri);
        //     link.setAttribute("download", "csv_corrige.csv");
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        // },

        telechargerCsvCorrige() {
            // Ajouter les corrections avant l'export
            this.ajouterColonneCorrections();

            let csvContent = "\uFEFF"; // UTF-8 BOM pour Excel

            // Définir l'ordre des colonnes
            const headers = ["n_ligne", ...Object.keys(this.parse_csv[0]).filter(h => h !== "n_ligne")];
            csvContent += headers.join(";") + "\n";

            // Fonction d'échappement CSV (gère les valeurs contenant ; " \n etc.)
            const escapeCSVValue = (value) => {
                if (value == null) return "";
                value = value.toString();
                if (value.includes(";") || value.includes("\"") || value.includes("\n")) {
                    return `"${value.replace(/"/g, '""')}"`;
                }
                return value;
            };

            // Ajouter toutes les lignes
            this.parse_csv.forEach(row => {
                const values = headers.map(h => escapeCSVValue(row[h]));
                csvContent += values.join(";") + "\n";
            });

            // Créer un Blob pour forcer un téléchargement correct
            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const url = URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "csv_corrige.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        },


		formatMarkers(parcelles) {
			return parcelles
				.map((parcelle) => {
					if (!parcelle || !parcelle.x || !parcelle.y) {
						return null;
					}

					let latitude = parseFloat(parcelle.x) || 0;
					let longitude = parseFloat(parcelle.y) || 0;

					if (isNaN(latitude) || isNaN(longitude)) {
						console.error(`Coordonnées invalides pour ${parcelle.nom_commune || "Inconnu"} : ${parcelle.x}, ${parcelle.y}`);
						return null;
					}

					return {
						id: parcelle.id_plot || "inconnu",
						coordinates: [latitude, longitude],
						imageUrl: require('@/assets/map_icon_blue3.png'),
						infobulle: `
				<div>
				<p><strong>Nom parcelle :</strong> ${parcelle.nom_commune || "Non spécifié"}</p>
				<p><strong>Opérateur :</strong> ${parcelle.nom_operateur || "Non spécifié"}</p>
				</div>
			`,
					};
				})
				.filter((marker) => marker !== null);
		},

		checkCodeStation(item) {
			if (item.code_station != undefined || item.code_station != '') {
				return true
			}
		},

		get_departement_mycolis() {
			const departements = this.all_info_about_stades.map((item) => item.code_dept);

			// Utilisation de filter et indexOf pour éliminer les doublons
			const uniqueDepartements = departements.filter((value, index, self) => {
				return self.indexOf(value) === index; // Garde l'élément seulement si c'est la première occurrence
			});

			// Ajout de "Tous" au début de la liste deroulante qui en resulte
			return ["Tous", ...uniqueDepartements];
		},


		zoomUpdated(zoom) {
			this.zoom = zoom;
		},

		centerUpdated(center) {
			this.center = center;
		},

		// MAP 
		getPositionCarte() {
			var array = [];
			var sumLat = 0;
			var sumLong = 0;
			var nbParcelle = 0;

			this.all_info_about_stades.forEach(parcelle => {
				// Vérification stricte de la latitude et longitude
				let latitude = parseFloat(parcelle.x);
				let longitude = parseFloat(parcelle.y);

				if (!isNaN(latitude) && !isNaN(longitude)) {
					array.push({
						id: parcelle.ind_parcelle, // Identifiant de la parcelle
						coordinates: [latitude, longitude], // Coordonnées de la parcelle
						imageUrl: require('@/assets/map_icon_blue3.png'), // Icône sur la carte
						infobulle: `
				<div>
				<p><strong>Nom User :</strong> ${parcelle.nom_user}</p>
				</div>
			`
					});

					// Calcul de la somme des latitudes et longitudes pour le centre de la carte
					sumLat += latitude;
					sumLong += longitude;
					nbParcelle++;
				}
			});

			// Vérifier si au moins une parcelle valide est présente
			if (nbParcelle > 0) {
				var centerLat = sumLat / nbParcelle;
				var centerLong = sumLong / nbParcelle;

				this.carte.markers = array; // Ajout des marqueurs à la carte
				this.carte.zoom = 6; // Zoom initial
				this.carte.center = [centerLat, centerLong]; // Centre de la carte
			} else {
				console.error("Aucune parcelle avec des coordonnées valides n'a été trouvée.");
			}
		},

		resultat_message(message_api) {

			var message_erreur_api = ''
			var titre = "Import réalisé avec succés"
			var nb_erreur = Object.keys(message_api.erreur).length
			if (nb_erreur > 0) {
				for (const [key, value] of Object.entries(message_api.erreur)) {
					message_erreur_api += '<br>' + key + ' : ' + value
				}
				titre = "Import avec erreur"
			}

			var description = `<div>
            <h4>Récapitulatif de votre import :</h4><br>
            
            <h5>Parcelles : </h5>
                <p><span style="color:darkgreen">${message_api.ajout}</span> création(s) de nouvelle(s) parcelle(s)<br>
                <p><span style="color:darkgreen">${message_api.modif}</span> Mise(s) à jour de parcelle(s)<br>
            <h5>Erreurs : </h5>
                <p><span style="color:darkred">${nb_erreur}</span> erreur(s) :</p>
                <p>${message_erreur_api}</p>
            </div>`

			//Affichage du message de confirmation d'import de parcelle
			this.$store.dispatch('informations/setInfo', {
				message: {
					titre: titre,
					description: description
				}
			});

		},


		/* GESTION DE L IMPORT DE CSV */
		async launchAddPlotInApi() {
			// Ferme la fenêtre de prévisualisation du CSV
			this.dialog_view_csv = false;

			// Définition de la taille des lots
			var size = 200; // Le CSV sera découpé en blocs de 200 lignes
			var csv_small = []; // Tableau temporaire pour stocker un lot de lignes
			var data = {}; // Objet contenant les données envoyées à l'API

			// Objet pour stocker les résultats de l'importation
			var message_retour = {
				ajout: 0, // Compteur du nombre d'ajouts réussis
				modif: 0, // Compteur du nombre de modifications réussies
				erreur: {} // Stockage des erreurs retournées par l'API ou d'autres erreurs
			};

			// LOADING
			this.$store.dispatch('general/setWaitingOverlay', {
				loading: true,
				fullpage: true
			});

			for (var i = 0; i < this.parse_csv.length; i += size) {
				csv_small = this.parse_csv.slice(i, i + size);
				data = {
					csv: csv_small,
					client: this.selected_user_mycolis,
					from_mycolis: 'from_mycolis'
				};

				// ⏳ Envoi du lot de 200 lignes à l'API et attente de la réponse
				try {
					//console.log(`📦 Traitement du batch ${Math.floor(i / size) + 1} (${i + 1} à ${i + csv_small.length})`);

					var resultat = await parcellesStadeService.addPlotInApi(data);

					message_retour.ajout += resultat.ajout ?? 0; // Ajout des lignes insérées
					message_retour.modif += resultat.modif ?? 0; // Ajout des lignes modifiées
					Object.assign(message_retour.erreur, resultat.erreur); // Fusion des erreurs retournées
				} catch (e) {
					// Gestion d'erreur si l'appel API échoue pour un batch
					console.error(`❌ Erreur lors du batch ${Math.floor(i / size) + 1}:`, e);
					message_retour.erreur[`Batch ${Math.floor(i / size) + 1}`] = e.message || 'Erreur inconnue';
				}
			}

			// Infos et loading visuel
			this.dialog_api = true;
			this.message_api = message_retour;

			this.$store.dispatch('general/setWaitingOverlay', {
				loading: false,
				fullpage: true
			});
		}

        ,

		sortBy: function (key) {
			this.sortKey = key
			this.sortOrders[key] = this.sortOrders[key] * -1
		},

		/**
		 * Convertir le CSV transmit en Objet JSON
		 */
		csvToJSON(csv) {
			var vm = this
			var lines = csv.split("\r\n")
			var result = []
			var headers = lines[0].split(";")
			vm.parse_header = lines[0].split(";")
			lines[0].split(";").forEach(function (key) {
				vm.sortOrders[key] = 1
			})

			lines.map(function (line, indexLine) {
				if (indexLine < 1) return // Jump header line
				var obj = {}
				var currentline = line.split(";")
				headers.map(function (header, indexHeader) {
					obj[header] = currentline[indexHeader]
				})
				result.push(obj)
			})
			result.pop() // remove the last item because undefined values
			return result // JavaScript object
		},

		/**
		 *   Lire le fichier importé et s'assurer de sa bonne lecture avant lancement du traintement
		 */
        viewCSV() {
            if (!this.chosenFile) {
                //Evite de lire un fichier vide ou un input file vide
                return;
            }

            if (window.FileReader) {
                var reader = new FileReader();

                // Forcer l'encodage en UTF-8
                reader.readAsText(this.chosenFile, "UTF-8");

                reader.onload = () => {
                    var csv = reader.result;  // Le contenu du fichier CSV
                    // Vérifie si l'encodage est correct en affichant le contenu dans la console
                    // Transformer le CSV en JSON
                    this.parse_csv = this.csvToJSON(csv);
                    this.nbr_plot_csv = this.parse_csv.length;
                    // console.log("CSV Transformé en JSON :", this.parse_csv);
                };

                reader.onerror = function (evt) {
                    if (evt.target.error.name === "NotReadableError") {
                        alert("Le fichier ne peut pas être lu !");
                    }
                };
            } else {
                alert("FileReader n'est pas compatible avec votre navigateur.");
            }
        },

		getNomFichier() {
			var now = new Date()
			now = getDate(now, 'yyyymmdd')
			return now + '_import_mycolis.xls'
		},

		/**
		 * Analyse les données du CSV pour s'assurer de la conformité des données et communiquer sur les ecarts AVANT mise en BDD
		 */
		checkConformCSVdata() {

            // Vérification de l'en-tête du CSV avant de traiter les données
            const headers = Object.keys(this.parse_csv[0]); // Récupère les noms des colonnes du CSV
            if (!this.checkCSVHeader(headers)) {
                console.warn("❌ L'en-tête du CSV est incorrect. Vérifiez les colonnes obligatoires.");
                return;
            }

			if (!this.liste_variete_ble || this.liste_variete_ble.length === 0) {
				console.warn("❌ La liste des variétés fusionnées est vide ou non chargée.");
				return;
			}

			if (!this.liste_precedents || this.liste_precedents.length === 0) {
				console.warn("❌ La liste des précédents est vide ou non chargée.");
				return;
			}

            // Vérifier la présence de la colonne "personnalisation"
            let colonnePersonnalisationPresente = this.parse_csv.length > 0 && "personnalisation" in this.parse_csv[0];

			// Extraire les données API en minuscules
			this.apiVarieties = this.liste_variete_ble.map(v => v.variete.toLowerCase());
			this.apiPrecedents = this.liste_precedents.map(p => this.normaliserTexte(p.codeaee));

			// Initialisation des compteurs
			let totalLignes = this.parse_csv.length;
			let erreursEspece = 0 , erreursVariete = 0, erreursCodeParcelle = 0 , erreursPrecedent = 0, erreursDateSemis = 0,erreursLabour=0, erreursSurface = 0 , nbrErreurGlobal = 0 , erreursCoordonnees = 0 , erreursLocalisation = 0 , erreursExploitation = 0 , erreursCodeExploitation = 0;

            // Stock des futurs codes parcelles du csv pour verif des doublons
            let codesParcellesRencontres = new Set();

			// Tableau pour stocker le détail des erreurs - pour affichage ulterieur
			let csvErrors = [];
			let missingPrecedentsErrors = [];

			// Définir les bornes pour la date de semis (période autorisée)
			let currentYear = new Date().getFullYear();
			let startDate = new Date(currentYear - 1, 8, 13); // 13 septembre N-1 (mois 8 = septembre)
			let endDate = new Date(currentYear, 0, 9); // 9 janvier N (mois 0 = janvier)

			// Vérifier chaque ligne du CSV
			this.parse_csv.forEach((row, index) => {
				let numLigne = index + 1;
				let erreursLigne = [];
                
                // Vérification de la personnalisation
                if (colonnePersonnalisationPresente) {
                    if (!row.personnalisation || row.personnalisation.trim() == "") {
                        //console.log(`⚠️ Personnalisation manquante à la ligne ${numLigne}`);
                    }
                }
                // creation de la colonne nom_parcelle avec un format specifique
                row.nom_parcelle = `${row.code_exploitation}|${row.personnalisation}`;
                        
                // Vérification de l exploitation 
                if (!this.checkExploitation(row, numLigne)) {
                    erreursExploitation++;
                    erreursLigne.push(`Erreur d'exploitation.`);
                }

                // Vérification du code exploitation 
                if (!this.checkCodeExploitation(row, numLigne)) {
                    erreursCodeExploitation++;
                    erreursLigne.push(`Erreur de code exploitation.`);
                }

                // Vérification du code parcelle 
                if (!this.checkDoublonCodeParcelle(row, numLigne, codesParcellesRencontres)) {
                    erreursCodeParcelle++;
                    erreursLigne.push(`Erreur code parcelle en doublon.`);
                }

				// Vérification de l'espèce
                let especeValide = this.checkEspece(row, numLigne);
                if (!especeValide) {
                    erreursEspece++;
                    erreursLigne.push(`Erreur d’espèce.`);
                }

                // Vérification de la variété (uniquement si l’espèce est valide)
                if (especeValide && !this.checkVariete(row, numLigne)) {
                    erreursVariete++;
                    erreursLigne.push(`Erreur de variété.`);
                }

				// Vérification du précédent 
				if (!this.checkPrecedent(row, numLigne,missingPrecedentsErrors)) {
					erreursPrecedent++;
					erreursLigne.push(`Erreur de précédent.`);
				}

				// Vérification de la date de semis
				if (!this.checkDateSemis(row, numLigne, startDate, endDate)) {
					erreursDateSemis++;
					erreursLigne.push(`Erreur de date de semis.`);
				}

                // Vérification de la commune et du code postal
                let localisationMessage = this.checkLocalisationEtCoordonnees(row, numLigne);
                if (localisationMessage) {
                    erreursLocalisation++;
                    erreursLigne.push(localisationMessage);
                }
                
				// Vérification du labour
				if (!this.checkLabour(row)) {
					erreursLabour++;
					erreursLigne.push(`Erreur de labour.`);
				}

                // Vérification de la surface 
				if (!this.checkSurface(row, numLigne)) {
					erreursSurface++;
					erreursLigne.push(`Erreur de surface.`);
				}

                ///TAUX ERREUR 
				// Liste des erreurs non bloquantes
                const erreursNonBloquantes = [
                    "Code INSEE manquant",
                    "Coordonnées hors des limites géographiques de la France métropolitaine",
                    "Coordonnées absentes et impossibles à compléter sans code postal et commune",
                    "Coordonnées manquantes et non retrouvées à partir du code postal et de la commune."
                ];
                if (erreursLigne.length > 0) {
                    csvErrors.push({
                        ligne: numLigne,
                        erreurs: erreursLigne,
                        row: row
                    });

                    const ligneContientUniquementErreursNonBloquantes = erreursLigne
                        .flatMap(erreur => erreur.split(" / ")) // Sépare les messages concaténés
                        .every(erreur =>
                            erreursNonBloquantes.some(nonBloquante => erreur.trim().includes(nonBloquante))
                        );
                    // Si la ligne contient uniquement des erreurs non bloquantes, ne pas incrémenter nbrErreurGlobal
                    if (!ligneContientUniquementErreursNonBloquantes) {
                        nbrErreurGlobal++;
                    }
                    
                }

			});// FIN BOUCLE CSV

            // Si des précédents manquent, envoyer un email
            if (missingPrecedentsErrors.length > 0) {
                this.sendMissingPrecedentsEmail(missingPrecedentsErrors);
            }

            // Calcul du pourcentage d'erreur
            this.tauxErreur = (nbrErreurGlobal / totalLignes) * 100;
            let parcellesImportees = totalLignes - nbrErreurGlobal;

            let summaryMessage = `Parcelles en erreur ${nbrErreurGlobal} sur ${totalLignes} :\n`;

            // Détermination du message d'import
            if (this.tauxErreur > 0) {
                summaryMessage += `\n🚨 Attention : Parcelles en erreur  \n`;
            } else {
                summaryMessage += `\n✅ ${parcellesImportees} parcelles importées  \n`;
            }
			// * Parametrage et Affichage du message dans la modale pour informer l'user
            let { totalSansAucuneInfo, inseeManquant, communeOuCpManquant, gpsHorsBornes,coordonnees_non_retrouvees } = this.statsLocalisation;

            // Vérifier les erreurs liées aux informations de localisation
            const bilanErreursLocalisation = [
                { count: inseeManquant, message: `⚠️  ${inseeManquant} parcelle(s) sans code INSEE` },
                { count: communeOuCpManquant, message: `⚠️  ${communeOuCpManquant} parcelle(s) sans commune ou code postal` },
                { count: gpsHorsBornes, message: `⚠️  ${gpsHorsBornes} parcelle(s) avec des coordonnées hors des bornes géographiques de la France métropolitaine` },
                { count: coordonnees_non_retrouvees, message: `⚠️  ${coordonnees_non_retrouvees} parcelle(s) avec des coordonnées manquantes et non retrouvées à partir du code postal et de la commune.` }
            ];
            
            let iconeExploitation = erreursExploitation > 0 ? "❌" : "✅";
			let iconeCodeExploitation = erreursCodeExploitation > 0 ? "❌" : "✅";
			let iconeCodeParcelle = erreursCodeParcelle > 0 ? "❌" : "✅";
			let iconeEspece = erreursEspece > 0 ? "❌" : "✅";
			let iconeVariete = erreursVariete > 0 ? "❌" : "✅";
			let iconePrecedent = erreursPrecedent > 0 ? "❌" : "✅";
			let iconeDateSemis = erreursDateSemis > 0 ? "❌" : "✅";
			let iconeSurface = erreursSurface > 0 ? "❌" : "✅";
			let iconeLabour = erreursLabour > 0 ? "❌" : "✅";
            let iconeLocalisation = totalSansAucuneInfo > 0 ? "❌" : "✅";

            summaryMessage += `- ${iconeExploitation} ${erreursExploitation} parcelle(s) avec un problème d'exploitation\n`;
            summaryMessage += `- ${iconeCodeExploitation} ${erreursCodeExploitation} parcelle(s) avec un problème de code exploitation\n`;
            summaryMessage += `- ${iconeCodeParcelle} ${erreursCodeParcelle} parcelle(s) avec un problème de code parcelle en doublon\n`;
            summaryMessage += `- ${iconeEspece} ${erreursEspece} parcelle(s) avec un problème d'espèce\n`;
            summaryMessage += `- ${iconeLocalisation} ${totalSansAucuneInfo} parcelle(s) sans aucune info de localisation (Lat, Long, code INSEE, CP, Commune)\n`;

           // Parcourir les erreurs et les ajouter au message si supérieur à zéro
           bilanErreursLocalisation.forEach(erreur => {
                if (erreur.count > 0) {
                    summaryMessage += `  ${erreur.message}\n`;
                }
            });

			summaryMessage += `- ${iconeVariete} ${erreursVariete} parcelles avec un problème de variété\n`;
			summaryMessage += `- ${iconePrecedent} ${erreursPrecedent} parcelles avec un problème de précédent\n`;
			summaryMessage += `- ${iconeDateSemis} ${erreursDateSemis} parcelles avec un problème de date de semis\n`;
			summaryMessage += `- ${iconeSurface} ${erreursSurface} parcelles avec un problème de surface\n`;
			summaryMessage += `- ${iconeLabour} ${erreursLabour} parcelles avec un problème de labour\n`;


			// Stocker le résumé et le détail pour la modale
			this.csvSummary = summaryMessage;
			this.csvErrorsDetailByLigne = csvErrors;

			// Afficher la modale de bilan
			this.dialog_bilan_check_csv = true;
		},

        checkCSVHeader(headers) {
            // Liste des champs obligatoires (casse exacte)
            const requiredHeaders = [
                'code_exploitation', 'nom_parcelle', 'code_parcelle', 'espece', 
                'variete', 'date_semis', 'labour', 'precedent', 'surface'
            ];

            // Vérifier si chaque élément de requiredHeaders est bien présent dans headers
            let missingHeaders = requiredHeaders.filter(header => !headers.includes(header));
            if (missingHeaders.length > 0) {
                console.warn(`❌ Champs manquants ou incorrects dans l'entête :`, missingHeaders);
                return false;
            }
            return true;
        },

        /**
         * Reset des données liées au scan et verification du fichier csv
         */
        resetFormAndDataErrors() {
            this.tauxErreur = 0; 
            this.suggestion_toutes_prises = false;
            this.csvErrorsVar = []; 
            this.csvErrorsDetailByLigne =[];
            this.csvSummary = ""  ;

            // Reset des compteurs de localisation
            this.statsLocalisation = {
                totalSansAucuneInfo: 0,
                inseeManquant: 0,
                communeOuCpManquant: 0,
                gpsHorsBornes: 0,
                coordonnees_non_retrouvees:0
            };

        },

		/**
		 * Fonction pour calculer la distance de Levenshtein entre deux mots
		 * @param premier_mot 
		 * @param second_mot 
		 */
		distance_levenshtein(premier_mot, second_mot) {
			// Initialisation d'une matrice (tableau 2D) qui va stocker les distances entre les sous-chaînes
			const matrice_levenshtein = [];

			// Si l'un des mots est vide, la distance est simplement la longueur de l'autre mot (car il faut ajouter ces lettres pour correspondre)
			if (!premier_mot.length) return second_mot.length;
			if (!second_mot.length) return premier_mot.length;

			// Remplir la première ligne de la matrice avec les indices de 0 à la longueur du second mot
			// Cela représente le coût de passer de la chaîne vide a second mot (supprimer tous les caractères)
			for (let i = 0; i <= second_mot.length; i++) matrice_levenshtein[i] = [i];

			// Remplir la première colonne de la matrice avec les indices de 0 à la longueur du premier mot
			// Cela représente le coût de passer du premier mot à une chaîne vide (ajouter tous les caractères)
			for (let j = 0; j <= premier_mot.length; j++) matrice_levenshtein[0][j] = j;

			// Remplir la matrice avec les valeurs appropriées, en calculant la distance entre chaque paire de sous-chaînes
			for (let i = 1; i <= second_mot.length; i++) {
				for (let j = 1; j <= premier_mot.length; j++) {
					// Si les caractères des deux mots à la position i et j sont égaux
					if (second_mot.charAt(i - 1) === premier_mot.charAt(j - 1)) {
						// Pas de modification nécessaire, on prend la valeur de la case diagonale (i-1, j-1)
						matrice_levenshtein[i][j] = matrice_levenshtein[i - 1][j - 1];
					} else {
						// Si les caractères sont différents, on prend la valeur minimale parmi trois options :
						// 1. Remplacer un caractère (case diagonale + 1)
						// 2. Supprimer un caractère du premier mot (case au-dessus + 1)
						// 3. Ajouter un caractère au premier mot (case à gauche + 1)
						matrice_levenshtein[i][j] = Math.min(
							matrice_levenshtein[i - 1][j - 1] + 1, // Remplacement
							matrice_levenshtein[i][j - 1] + 1, // Insertion
							matrice_levenshtein[i - 1][j] + 1 // Suppression
						);
					}
				}
			}

			// La distance de Levenshtein est la valeur dans la dernière cellule de la matrice (en bas à droite)
			// Cette valeur représente le nombre minimal d'opérations pour transformer le premier mot en le second
			return matrice_levenshtein[second_mot.length][premier_mot.length];
		},

        
        /**
         * Normer le texte en enlevant les espaces les accents
         * @param texte 
         */
		normaliserTexte(texte) {
			return texte.toLowerCase()
				.normalize("NFD").replace(/[\u0300-\u036f]/g, "")  // Supprime les accents
				.replace(/\s+/g, " ")  // Remplace les espaces multiples par un seul espace
				.trim(); // Supprime les espaces en début et fin
		},

        formatSuggestionsText(suggestions) {
            // Si suggestions est une chaîne de texte (par exemple, "geo, grekau")
            if (typeof suggestions === 'string') {
                let suggestionList = suggestions.split(',').map(s => s.trim());

                if (suggestionList.length < 5) {
                    return `Veuillez saisir la bonne suggestion : ${suggestionList.join(", ")}`;
                } else {
                    return `Veuillez saisir parmi la liste ci-contre`;
                }
            }

            // Si aucune suggestion valide, on retourne un message générique
            return "Veuillez saisir selon la liste ci-contre";
        },

        reparerEncodage(texte) {
            if (!texte) return texte;
            return texte
                .replace(/Ã©/g, "é")
                .replace(/Ã¨/g, "è")
                .replace(/Ã¢/g, "â")
                .replace(/Ã´/g, "ô")
                .replace(/Ã§/g, "ç")
                .replace(/Ã«/g, "ë")
                .replace(/Ã¼/g, "ü")
                .replace(/Ã¯/g, "ï") 
                .replace(/Ã/g, "à")
                .replace(/è/g, "é") 
                .toLowerCase();  
        },

        // Fonction de contrôle pour vérifier que les données d'exploitation ne sont pas vides
        checkExploitation(row, numLigne) {
            let erreursLigne = [];

            // Vérifie si la donnée de l'exploitation est vide
            if (!row.exploitation || row.exploitation.trim() === '') {
                erreursLigne.push('Erreur: Le champ "Exploitation" est vide.');
            }

            // Si des erreurs sont trouvées pour cette ligne, on les retourne
            if (erreursLigne.length > 0) {
                return false; // Renvoie false pour indiquer une erreur
            }

            return true; // Tout est ok pour cette ligne
        },

        // Fonction de contrôle pour vérifier que l'ID d'exploitation n'est pas vide
        checkCodeExploitation(row) {
            let erreursLigne = [];

            // Vérifie si l'ID d'exploitation est vide
            if (!row.code_exploitation || row.code_exploitation.trim() === '') {
                erreursLigne.push('Erreur: Le champ "code_exploitation" est vide.');
            }

            if (erreursLigne.length > 0) {
                return false; // Renvoie false pour indiquer une erreur
            }

            return true; // Tout est ok pour cette ligne
        },


        checkEspece(row) {
            if (row.espece) {
                let csvEspece = this.normaliserTexte(this.reparerEncodage(row.espece)).trim(); // Corrige l'encodage

                let type_ble = "";
                if (csvEspece.includes("ble tendre") || csvEspece.includes("blé tendre")) {
                    type_ble = "ble tendre"; 
                } else if (csvEspece.includes("ble dur") || csvEspece.includes("blé dur")) {
                    type_ble = "ble dur";
                } else {
                    return false;
                }
                return type_ble;            
             }
            return false;//Si row.espece est vide
        },

        checkDoublonCodeParcelle(row, numLigne, codesParcellesRencontres) {
            let codeParcelleLuActuellement = row.code_parcelle ? row.code_parcelle.trim() : '';
            if (codesParcellesRencontres.has(codeParcelleLuActuellement)) {
                //console.log(`❌ Erreur : Code parcelle "${codeParcelleLuActuellement}" en doublon (ligne ${numLigne}).`);
                return false;
            }
            // Ajout du code parcelle dans le Set pour suivi
            codesParcellesRencontres.add(codeParcelleLuActuellement);
            return true;
        },

        /**
         * Verifier que la variete de la ligne du CSV est cohérente/présente avec notre BDD
         * @param row 
         * @param numLigne 
         */
         checkVariete(row, numLigne) {
            if (row.variete && row.espece) {
                // Normalisation après réparation de l'encodage
                let csvVariete = this.normaliserTexte(this.reparerEncodage(row.variete)).trim();
                let csvEspece = this.normaliserTexte(this.reparerEncodage(row.espece)).trim();
                let type_ble = "";

                // Correspondances souples pour l'espèce (avec ou sans accents)
                if (csvEspece.includes("ble tendre") || csvEspece.includes("blé tendre")) {
                    type_ble = "bletendre";
                } else if (csvEspece.includes("ble dur") || csvEspece.includes("blé dur")) {
                    type_ble = "bledur";
                } else {
                    console.warn(`⚠️ Ligne ${numLigne} : Espèce "${row.espece}" non reconnue.`);
                    return false;
                }

                let varietesPossibles = this.liste_variete_ble
                    .filter(v => v.type_espece && this.normaliserTexte(v.type_espece.toLowerCase()).replace(/\s+/g, '') === type_ble.replace(/\s+/g, ''))
                    .map(v => v.variete ? this.normaliserTexte(v.variete).trim() : "");
                // Vérifier si la variété est valide
                if (varietesPossibles.includes(csvVariete)) {
                    //console.log(`✅ Ligne ${numLigne} : La variété "${row.variete}" est valide pour l'espèce "${row.espece}".`);
                    return true;  // La variété est valide
                } else {
                    //console.warn(`❌ Ligne ${numLigne} : La variété "${row.variete}" n'est pas valide pour l'espèce "${row.espece}".`);
                    // Si la variété n'est pas valide, proposer des suggestions basées sur la distance de Levenshtein
                    let suggestions = varietesPossibles
                        .map(v => ({
                            nom: v,
                            score: this.distance_levenshtein(csvVariete, v)
                        }))
                        .filter(s => s.score > 0 && s.score <= 2)  // Seulement les variétés avec un faible score de différence
                        .sort((a, b) => a.score - b.score)  // Tri des suggestions par score
                        .slice(0, 5);  // Limiter à 5 suggestions

                    let suggestionsString = suggestions.length > 0
                        ? suggestions.map(s => s.nom).join(", ")
                        : varietesPossibles.join(", ");  // Si aucune suggestion, afficher toutes les variétés possibles

                    // Ajouter une erreur dans la liste des erreurs de CSV
                    this.csvErrorsVar.push({
                        ligne: numLigne,
                        espece: type_ble,
                        erreur: `Variété "${row.variete}" incorrecte pour l'espèce "${csvEspece}".`,
                        suggestions: suggestionsString,
                        row: row
                    });

                    return false;  // La variété est incorrecte
                }
            }
            return false;  // Si l'espèce ou la variété est manquante
        },

        /**
         * Verifier que le precedent de la ligne du CSV est cohérente/présente avec notre BDD 
         * @param row 
         * @param numLigne 
         * @param missingPrecedentsErrors 
         */
         checkPrecedent(row, numLigne, missingPrecedentsErrors) {
            if (row.precedent) {
                const repairedPrecedent = this.reparerEncodage(row.precedent);
                const csvPrecedent = this.normaliserTexte(repairedPrecedent);

                if (this.apiPrecedents.includes(csvPrecedent)) {
                    return true;
                } else {
                    missingPrecedentsErrors.push({
                        ligne: numLigne,
                        precedent: repairedPrecedent // version lisible dans l'email
                    });
                    return false;
                }
            }
            return false;
        }
        ,

        /**
         * Verifier que la surface de la ligne du CSV est cohérente 
         * @param row 
         * @param numLigne 
         */
        checkSurface(row, numLigne) {
            let surface = row.surface;
            let surfaceWithDot = surface.replace(',', '.'); // Remplace la virgule par un point pour compatibilité
            let parsedSurface = parseFloat(surfaceWithDot);

            // Vérification cohérence si la surface est vide, non-numerique, ou inf égale à 0
            if (surface === "" || isNaN(parsedSurface) || parsedSurface <= 0) {
                //console.warn(`Surface invalide à la ligne ${numLigne}: ${surface}`);
                return false;
            }
            return true;
        },

        /**
         * Verifier que la date de semis de la ligne du CSV est cohérente [13/09/N-1 - 09/01/N]
         * @param row 
         * @param numLigne 
         * @param startDate 
         * @param endDate 
         */
         checkDateSemis(row, numLigne, startDate, endDate) {
            if (row.date_semis) {
                // Supprimer les espaces avant et après la date
                row.date_semis = row.date_semis.trim();

                // Vérifier que la date est bien dans le format DD/MM/YYYY
                const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
                if (!regex.test(row.date_semis)) {
                    return false;  // Si le format est invalide
                }

                // Convertir la date au format DD/MM/YYYY en un objet Date
                let parts = row.date_semis.split('/');
                let csvDateSemis = new Date(parts[2], parts[1] - 1, parts[0]);

                if (isNaN(csvDateSemis)) {
                    return false;  // Si la date n'est pas valide
                } else if (csvDateSemis > startDate && csvDateSemis < endDate) {
                    // Si la date est strictement dans la plage, sans inclure les bornes
                    return true;
                } else {
                    return false;  // Si la date est égale à la borne ou en dehors de la plage
                }
            } else {
                return false;  // Si la date de semis n'est pas fournie
            }
        }


        ,


        /**
         * Vérifier que la valeur du champ 'labour' est cohérente
         * @param labour 
         */
        checkLabour(row, numLigne) {
            let labour = row.labour;
            let labourUpper = labour.toUpperCase(); // Convertir en majuscule pour comparaison insensible à la casse
            // Vérification si la valeur ainsi (pour convenir à un false)
            if (labourUpper === "NON" || labourUpper === "N" || labour === 0 || labour == false || labour === "false" || labour =="non labour ") {
                return true;
            }
            // Vérification si la valeur est ainsi (pour convenir à un true)
            else if (labourUpper === "OUI" || labourUpper === "O" || labour === 1 || labour == true || labour === "true" || labour === "labour") {
                return true;
            }
            // Si la valeur est invalide, on envoie un message et retourne false
            else {
                console.warn(`Valeur invalide pour le champ 'labour' à la ligne ${numLigne}: ${labour}`);
                return false;
            }
        },

        checkLocalisationEtCoordonnees(row, numLigne) {
            let arr_error_localisation = [];

            // Normalisation des données
            let codeInsee = typeof row.code_insee === "string" ? row.code_insee.trim() : "";
            let latitude = typeof row.latitude === "string" ? row.latitude.trim() : row.latitude;
            let longitude = typeof row.longitude === "string" ? row.longitude.trim() : row.longitude;
            let codePostal = typeof row.code_postal === "string" ? row.code_postal.trim() : "";
            let commune = typeof row.commune === "string" ? row.commune.trim() : "";

            let hasInsee = codeInsee !== "" && codeInsee !== "NA";
            let hasLatLon = latitude && longitude && latitude !== "NA" && longitude !== "NA";
            let hasCPCommune = codePostal !== "" && commune !== "" && codePostal !== "NA" && commune !== "NA";

            // Vérification générale de localisation complète (code INSEE + coordonnées GPS + code postal/commune)
            if (!hasInsee && !hasLatLon && !hasCPCommune) {
                arr_error_localisation.push("Aucune information de localisation (code INSEE, coordonnées ou code postal + commune absents)");
                this.statsLocalisation.totalSansAucuneInfo++; // Compte cette ligne comme n'ayant aucune info de localisation

                // Si aucune information de localisation, on arrête la vérification et on passe à la ligne suivante
                this.csvErrorsDetailByLigne.push({
                    ligne: numLigne,
                    erreurs: arr_error_localisation
                });
                return arr_error_localisation.join(" / ");
            }

            // Coordonnées invalides ?
            const latInvalid = !latitude || isNaN(parseFloat(latitude));
            const lonInvalid = !longitude || isNaN(parseFloat(longitude));

            if (latInvalid || lonInvalid) {
                // Tentative de récupération via CP + commune
                if (codePostal && commune) {
                    const match_found = this.getCoordinatesFromLocalData(codePostal, commune);
                    if (match_found) {
                        row.latitude = match_found.latitude;
                        row.longitude = match_found.longitude;
                        row.code_postal = match_found.code_postal;
                        row.code_insee = match_found.code_insee;
                        latitude = match_found.latitude;
                        longitude = match_found.longitude;
                    } else {
                        arr_error_localisation.push("Coordonnées manquantes et non retrouvées à partir du code postal et de la commune.");
                        this.statsLocalisation.coordonnees_non_retrouvees++;
                    }
                } else {
                    arr_error_localisation.push("Coordonnées absentes et impossibles à compléter sans code postal et commune.");
                }
            } else {
                // Coordonnées valides, tester bornes géographiques
                latitude = parseFloat(latitude);
                longitude = parseFloat(longitude);

                const horsFrance = latitude < 42 || latitude > 52 || longitude < -5 || longitude > 8;

                if (horsFrance) {
                    if (codePostal && commune) {
                        const match_found = this.getCoordinatesFromLocalData(codePostal, commune);
                        if (match_found) {
                            row.latitude = match_found.latitude;
                            row.longitude = match_found.longitude;
                            row.code_postal = match_found.code_postal;
                            row.code_insee = match_found.code_insee;
                            this.statsLocalisation.coordonnees_recalculees = (this.statsLocalisation.coordonnees_recalculees || 0) + 1;
                        } else {
                            arr_error_localisation.push("Coordonnées hors des limites géographiques de la France et non retrouvées à partir du code postal et de la commune.");
                            this.statsLocalisation.gpsHorsBornes++;
                        }
                    } else {
                        arr_error_localisation.push("Coordonnées hors des limites géographiques de la France métropolitaine.");
                        this.statsLocalisation.gpsHorsBornes++;
                    }
                }
            }

            // Si tout est ok, on retourne les erreurs éventuelles
            if (arr_error_localisation.length > 0) {
                this.csvErrorsDetailByLigne.push({
                    ligne: numLigne,
                    erreurs: arr_error_localisation
                });
            }

            return arr_error_localisation.join(" / ");
        },

    
        /**
         *  Fonction pour récupérer les coordonnées à partir des données JSON déjà disponibles selon celles fournies par le csv de l'user
         */
        getCoordinatesFromLocalData(codePostalPlotCSV, communePlotCSV) {
            // Normalisation de la commune entrée
            let normalizedCommune = this.normalizeCommuneName(communePlotCSV).trim();

            // 🔍 1. Recherche exacte (code postal + nom de commune)
            let matchedData = this.list_all_cp_gouv.find(item =>
                item.code_postal == codePostalPlotCSV &&
                this.normalizeCommuneName(item.nom_de_la_commune).trim() === normalizedCommune
            );

            if (matchedData && matchedData._geopoint) {
                let coords = matchedData._geopoint.split(',');
                return {
                    latitude: parseFloat(coords[0]),
                    longitude: parseFloat(coords[1]),
                    code_postal: matchedData.code_postal,
                    code_insee: matchedData.code_commune_insee
                };
            }

            // 🔄 2. Recherche approximative si aucun match exact

            // Extraction du département (2 premiers chiffres du code postal)
            const departement = codePostalPlotCSV.toString().padStart(5, '0').substring(0, 2);

            // Filtrage par département
            const filteredList = this.list_all_cp_gouv.filter(item =>
                item.code_postal && item.code_postal.startsWith(departement)
            );

            let minDistance = Infinity;
            let closest = null;

            for (let item of filteredList) {
                const normalizedItemCommune = this.normalizeCommuneName(item.nom_de_la_commune).trim();
                const distance = this.distance_levenshtein(normalizedCommune, normalizedItemCommune);

                if (distance < minDistance) {
                    minDistance = distance;
                    closest = item;
                }
            }

            // ⚠️ Seuil de tolérance pour dire que c’est un match "suffisamment proche"
            if (closest && minDistance <= 3 && closest._geopoint) {
                console.warn(`⚠️ Approximate match utilisé : "${closest.nom_de_la_commune}" (distance ${minDistance})`);
                let coords = closest._geopoint.split(',');
                return {
                    latitude: parseFloat(coords[0]),
                    longitude: parseFloat(coords[1]),
                    code_postal: closest.code_postal,   // Ajout du code postal
                    code_insee: closest.code_commune_insee  // Ajout du code INSEE
                };
            }

            return null;
        }

        ,

        sendMissingPrecedentsEmail(missingPrecedentsErrors) {

           // let destinataire = "c.censier@arvalis.fr";
            let destinataire ="j.seneze@arvalis.fr,e.morin@arvalis.fr,l.godon@arvalis.fr";
            let subject = "Alerte MYCOLIS : Précédents manquants dans le CSV";
            let body = "Bonjour \n\nLes précédents suivants sont absents de la base de données :\n\n";
            let expediteur = "no-reply@arvalis.fr";

            // Utiliser un Set pour éliminer les doublons
            let precedentsSet = new Set(missingPrecedentsErrors.map(err => err.precedent));

            body += Array.from(precedentsSet).join("\n");
            body += "\n\nMerci de les ajouter à la base de données.";

            // Appel à la fonction d'envoi d'email
            this.sendEmail(subject, body, destinataire,expediteur);
        }
        ,

		// Méthode d'envoi d'email
		async sendEmail(subject, body, destinataire, expediteur) {
			try {
				parcellesStadeService.sendEmail({
					subject: subject,
					body: body,
					destinataire: destinataire,
                    expediteur : expediteur
				});
			} catch (error) {
				console.error("Erreur lors de l'envoi de l'email :", error);
			}
		},

        formatSuggestions(espece, error) {
            let formattedSuggestions = [];

            // Vérifier que liste_variete_ble contient des données
            if (!this.liste_variete_ble || this.liste_variete_ble.length === 0) {
                console.warn("La liste des variétés est vide ou non définie");
                return [];
            }
            // Vérifier si les suggestions sont une chaîne "Veuillez saisir une variété"
            formattedSuggestions = this.liste_variete_ble
                .filter(variete => variete.type_espece === espece)
                .map(variete => variete.variete);
            // Si une seule suggestion existe, on la pré-sélectionne
            if (formattedSuggestions.length === 1) {
                this.$set(error, 'correction', formattedSuggestions[0]);
            }

            return formattedSuggestions;
        },

        ajouterColonneCorrections() {
            this.parse_csv.forEach((row, index) => {
                row.n_ligne = index + 1; // Ajouter le numéro de ligne

                let erreursAssociees = this.csvErrorsDetailByLigne
                    .filter(error => error.ligne === index + 1)
                    .flatMap(error => error.erreurs) // Au cas où plusieurs entrées
                    .filter(Boolean);

                // Joindre avec " / " et entourer de guillemets si erreurs
                row.corr_parcelle = erreursAssociees.length > 0
                    ? `"${erreursAssociees.join(" / ")}"`
                    : "ok";
            });
        },

        corrigerCsvPuisTelecharger() {
            // Appliquer les corrections de variété
            this.groupedErrorsVar.forEach(error => {
                if (error.correction) {
                    this.parse_csv.forEach(row => {
                        let erreurAssociee = this.csvErrorsVar.find(e => 
                            e.erreur === error.erreur && e.row === row
                        );
                        if (erreurAssociee) {
                            row.variete = error.correction; 
                        }
                    });
                }
            });

            // Nettoyage des erreurs de variété precedement corrigées
            this.csvErrorsDetailByLigne.forEach(error => {
                error.erreurs = error.erreurs.filter(e => !e.includes("variété"));
            });

            // Appliquer d'autres corrections sur toutes les lignes du CSV
            this.parse_csv.forEach(row => {
                //Correction du champ "labour"
                if (typeof row.labour === "string") {
                    let labour_trim = row.labour.trim().toLowerCase();  
                    // Cas pour TRUE
                    if (["o", "oui", "1", "true","labour"].includes(labour_trim)) {
                        row.labour = true;
                    }
                    // Cas pour FALSE
                    else if (["n", "non", "0", "false","non labour"].includes(labour_trim)) {
                        row.labour = false;
                    }
                    else {
                        // Valeur incorrecte ou non reconnue pour la logique Boolean du labour
                        row.labour = null; // supprime la clé
                    }
                }

                // Normalisation des textes
                let csvEspece = this.normaliserTexte(row.espece || "");// Normalisation de l'espèce
                row.espece = csvEspece; 

                // Détermination du type de blé
                let type_ble = "";
                if (csvEspece.includes("ble tendre")) {
                    type_ble = "BLE TENDRE";
                } else if (csvEspece.includes("ble dur")) {
                    type_ble = "BLE DUR";
                }

                // Ajoute le type de blé au champ libelle_culture
                if (type_ble) {
                    row.libelle_culture = type_ble;
                }

                // Création de champs specifiques au futur appel API Previlis
                row.codesol = null ;
                row.code_station = null ;
                // Suppression de champs non utile à l'appel futur 
                delete row["variete.check"] ;
                delete row.n_ligne ;
                delete row.corr_parcelle ;

                //Remplacement des virgules par des points dans les nombres
                if (row.latitude) row.latitude = row.latitude.toString().replace(",", ".");
                if (row.longitude) row.longitude = row.longitude.toString().replace(",", ".");
                if (row.lambert93x) row.lambert93x = row.lambert93x.toString().replace(",", ".");
                if (row.lambert93y) row.lambert93y = row.lambert93y.toString().replace(",", ".");

            });
            
            // Affichage du message de confirmation
            this.$store.dispatch('informations/setInfo', {
                message: {
                    titre: 'Correction appliquée',
                    description: 'Les corrections sélectionnées ont bien été appliquées avec succès.<br>Vous avez téléchargé le fichier corrigé.',
                }
            });
            if(this.tauxErreur == 0) {
                this.goToImport = true ;
            }

            // Télécharger le fichier corrigé
            this.telechargerCsvCorrige();
        },



        mettreAJourCorrection(error, correction) {
            this.$set(error, 'correction', correction);  // Assurer la réactivité avec $set
            this.$nextTick(() => {
                //console.log("Corrections mises à jour après le rendu:", this.groupedErrorsVar.map(e => e.correction));
            });
        },


        toutesSuggestionsRemplies() {
            let allValid = false ;

            // Si aucune erreur, alors tout est "rempli" par défaut
            if (this.groupedErrorsVar.length === 0) {
                this.suggestion_toutes_prises = true;
                return true;
            }

            allValid = this.groupedErrorsVar.every(error => {
                const correctionIsValid = error.correction && error.correction.trim() !== "";
                return correctionIsValid;
            });

            this.suggestion_toutes_prises = allValid;
            return allValid;
        }




	}

};

</script>

<style>

h3{
	margin:18px 0px 12px 0px;
	padding:0.5rem;
}

</style>